// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"450f753d","208":"a3712ee9","453":"4b8b135e","501":"41d49b29","568":"67aad360","929":"e6ed6434","992":"64a1ad1c"}[chunkId] + ".chunk.js";
};